import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import "./PasswordEmailEntry.css";
import { resetPassword } from "../../../redux/actions/loginRecoveryActions";
import { useDispatch } from "react-redux";
import { getPublicUrl } from '../../../utilities/env';

function getStrength(pw) {
  let score = 0;
  if (pw.length >= 8)  score++;
  if (pw.length >= 12) score++;
  if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) score++;
  if (/[0-9]/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;

  if (score <= 1) return { score, label: "Weak",      color: "#e74c3c" };
  if (score === 2) return { score, label: "Fair",      color: "#e67e22" };
  if (score === 3) return { score, label: "Good",      color: "#f1c40f" };
  if (score === 4) return { score, label: "Strong",    color: "#27ae60" };
                   return { score, label: "Very Strong", color: "#1a7a44" };
}

export default function NewPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const uid = searchParams.get('uid');
  const token = searchParams.get('token');

  const handleSubmit = () => {
    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setError("");
    dispatch(resetPassword({ uid, token, newPassword: password }));
    console.log("New password submitted:", password);
  };

  return (
    <div className="page">
        <img src={`${getPublicUrl()}/Status_Solutions_Logo-Header.svg`} alt="Status logo" className="statusLogo" />
      <div className="blob1" />
      <div className="blob2" />

      <div className="card">
        <h2 className="title">Set New Password</h2>
        <p className="subtitle">
          Password must be at least 8 characters.
        </p>

        {/* New Password */}
        <div className="fieldGroup">
          <label htmlFor="password">New Password:</label>
          <input
            id="password"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="inputEmail"
          />
          {password && (() => {
            const { score, label, color } = getStrength(password);
            return (
              <div className="strengthWrapper">
                <div className="strengthBar">
                  {[1, 2, 3, 4, 5].map((n) => (
                    <div
                      key={n}
                      className="strengthSegment"
                      style={{ background: n <= score ? color : "#ddd" }}
                    />
                  ))}
                </div>
                <span className="strengthLabel" style={{ color }}>{label}</span>
              </div>
            );
          })()}
        </div>

        {/* Confirm Password */}
        <div className="fieldGroup">
          <label htmlFor="confirmPassword">Confirm Password:</label>
          <input
            id="confirmPassword"
            type={showPassword ? "text" : "password"}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
            className="inputEmail"
          />
        </div>

        {/* Single toggle covers both fields */}
        <div className="toggleRow">
          <input
            type="checkbox"
            id="showPassword"
            checked={showPassword}
            onChange={() => setShowPassword((v) => !v)}
            className="toggleCheckbox"
          />
          <label htmlFor="showPassword" className="toggleLabel">
            Show Password
          </label>
        </div>

        {error && <p className="errorText">{error}</p>}

        <button className="submitBtn" onClick={handleSubmit}>
          UPDATE PASSWORD
        </button>

        <div className="linksRow">
          <a href="/index.php" className="linkToLogin">
            Back to Login
          </a>
        </div>
      </div>
    </div>
  );
}